<template>
  <div>
    <div class="flex flex-wrap gap-12">
      <div class="max-w-max md:max-w-[65%]">
        <p class="text-h4 mb-16">Profile progress</p>
        <p class="text-body w-full">Sitters who complete their profile are at least <b>4x more</b> likely to be hired.</p>
      </div>
      <div class="min-w-[146px] max-w-max m-auto md:mr-16">
        <completeness-meter :completenessPercentage="100" />
      </div>
    </div>
    <div class="mt-24">Step card list here</div>
  </div>
</template>

<script>
import CompletenessMeter from '@/components/completeness_meter/CompletenessMeter.vue';

export default {
  name: 'ProfileProgress',
  components: { CompletenessMeter },
};
</script>
